import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const nav = [
    { href: "#calculator", label: "Calculator" },
    { href: "#results", label: "Results" },
    { href: "#categories", label: "Services" },
    { href: "#how", label: "How It Works" },
    { href: "#process", label: "Process" },
    { href: "#playbook", label: "Playbook" },
    { href: "#pricing", label: "Pricing" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 inset-x-0 z-50 transition-all ${
                scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 h-20 flex items-center justify-between">
                <a href="#" data-testid="logo-link" className="flex items-center gap-3 group">
                    <img src="/lead-krafts-icon.png" alt="Lead Krafts" className="h-8 sm:h-9 w-8 sm:w-9 object-contain" />
                    <span className="font-serif-display text-xl tracking-wide">
                        Lead <span className="text-[#D4AF37] italic">Krafts</span>
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-8 mx-auto pl-12">
                    {nav.map((n) => (
                        <a
                            key={n.href}
                            href={n.href}
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                            className="text-sm text-white/70 hover:text-[#D4AF37] transition-colors tracking-wide"
                        >
                            {n.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-4">
                    <a href="#calculator" data-testid="header-cta" className="btn-gold text-sm">
                        Calculate My Indicative CPL
                    </a>
                </div>

                <button
                    data-testid="mobile-menu-toggle"
                    className="lg:hidden text-white/80"
                    onClick={() => setOpen(!open)}
                    aria-label="menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div data-testid="mobile-menu" className="lg:hidden bg-black/95 border-t border-white/10 px-6 py-6">
                    <div className="flex flex-col gap-4">
                        {nav.map((n) => (
                            <a
                                key={n.href}
                                href={n.href}
                                onClick={() => setOpen(false)}
                                className="text-white/80 hover:text-[#D4AF37]"
                            >
                                {n.label}
                            </a>
                        ))}
                        <a href="#lead" onClick={() => setOpen(false)} className="btn-gold w-fit">
                            Calculate My Indicative CPL
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
